module.exports = __webpack_public_path__ + "static/media/_DSC6175.e9d9bb8f.jpg";